
export enum NotificationCases {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  FAILED = 'failed',
  ERROR = 'error'

}

export enum NotificationProps {
  EMPTY_STRING = '',
  BUTTON_ROLE = 'button'
}

export enum NotificationThemeColors {
  BLUE = 'blue',
  ORANGE = 'orange',
  RED = 'red'
}